export default __webpack_public_path__ + "static/sailsquare-1bf8149d38a5888c25698e0ede46d135.svg";